import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { clsx as cx } from 'clsx';
import * as styles from './FormField.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FormField = function FormField(_ref) {
  var label = _ref.label,
    description = _ref.description,
    required = _ref.required,
    errorMessage = _ref.errorMessage,
    children = _ref.children;
  var _React$useState = React.useState("label_".concat(Math.round(Math.random() * 100000))),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    childId = _React$useState2[0];
  var shouldRenderLabel = label || description;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [shouldRenderLabel && /*#__PURE__*/_jsxs("label", {
      className: styles['label'],
      htmlFor: childId,
      children: [label && /*#__PURE__*/_jsx("span", {
        className: cx(styles['field-name'], required && styles['required']),
        children: label
      }), description && /*#__PURE__*/_jsx("span", {
        className: styles['field-description'],
        children: description
      })]
    }), children({
      id: childId
    }), errorMessage && /*#__PURE__*/_jsx("div", {
      className: styles['error'],
      children: errorMessage
    })]
  });
};
FormField.displayName = 'FormField';